
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';

	@Component({})
	export default class TopBar extends BaseView {

		public list: any[] = [
			{ link: 'https://facebook.com', icon: 'mdi-facebook' },
			{ link: 'https://twitter.com', icon: 'mdi-twitter' },
			{ link: 'https://instagram.com', icon: 'mdi-instagram' },
		];

	}
	
